import Axios from 'axios';
import { getAuthHeaders, getBaseUrl } from '../helpers/rulesApiHelpers';
import {
  BOXCHAMP_VALIDATE_REQUEST,
  BOXCHAMP_VALIDATE_SUCCESS,
  BOXCHAMP_VALIDATE_FAILURE,
  BOXCHAMP_QUEUE_REQUEST,
  BOXCHAMP_QUEUE_COMPLETE,
  BOXCHAMP_RESET,
} from '../constants';

export function validateBulkOrders(orderIds) {
  return async (dispatch) => {
    dispatch({ type: BOXCHAMP_VALIDATE_REQUEST });
    try {
      const url = await getBaseUrl();
      const headers = await getAuthHeaders();
      const response = await Axios({
        method: 'post',
        url: `${url}/box/validate_bulk.json`,
        headers,
        data: { order_ids: orderIds },
      });
      dispatch({ type: BOXCHAMP_VALIDATE_SUCCESS, payload: response.data });
    } catch {
      dispatch({
        type: BOXCHAMP_VALIDATE_FAILURE,
        payload: 'Failed to validate orders. Please try again.',
      });
    }
  };
}

export function queueOrders(readyOrders, onComplete) {
  return async (dispatch) => {
    dispatch({ type: BOXCHAMP_QUEUE_REQUEST });
    const url = await getBaseUrl();
    const headers = await getAuthHeaders();
    let queued = 0;

    for (const order of readyOrders) {
      try {
        await Axios({
          method: 'post',
          url: `${url}/box/calculate.json`,
          headers,
          data: { order_id: order.id },
        });
        queued++;
      } catch {
        // per-order failures are skipped; continue with remaining orders
      }
    }

    dispatch({ type: BOXCHAMP_QUEUE_COMPLETE, payload: queued });
    if (onComplete) onComplete(queued);
  };
}

export function resetBoxChamp() {
  return { type: BOXCHAMP_RESET };
}
